import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Header, Footer } from './Container';

function CogenRegistrationTermOfServices() {
	// const isLogin = localStorage.getItem('isLogin');
	return (
		<Container fluid='true' className='p-0'>
	  {/* {isLogin ? <Header type='member' /> : <Header type='client' />} */}

			{/* {isLogin && <Header type='member' />} */}
			{/* <Header type='client' /> */}
			<Container
				style={{
					backgroundColor: 'fff;',
					display: 'block',
					lineHeight: '2em',
					fontSize: '1.125em',
				}}
			>
				<Row className='mt-2'>
					<Col fluid='md' className='p-4'>
						<h1 style={{ textAlign: 'center', fontWeight: 'bold' }}>
							Terms Of Services
						</h1>
					</Col>
				</Row>
				<div>
					<h2 className='mb-4'>Terms and conditions</h2>
					<p style={{ textAlign: 'justify' }}>
						These terms and conditions (&#8220;Agreement&#8221;) set forth the
						general terms and conditions of your use of the{' '}
						<a href='https://GetCOGen.com'>GetCOGen.com</a> website
						(&#8220;Website&#8221;), &#8220;COGen&#8221; mobile application
						(&#8220;Mobile Application&#8221;) and any of their related products
						and services (collectively, &#8220;Services&#8221;). This Agreement
						is legally binding between you (&#8220;User&#8221;,
						&#8220;you&#8221; or &#8220;your&#8221;) and COGen, LLC
						(&#8220;COGen, LLC&#8221;, &#8220;we&#8221;, &#8220;us&#8221; or
						&#8220;our&#8221;). If you are entering into this agreement on
						behalf of a business or other legal entity, you represent that you
						have the authority to bind such entity to this agreement, in which
						case the terms &#8220;User&#8221;, &#8220;you&#8221; or
						&#8220;your&#8221; shall refer to such entity. If you do not have
						such authority, or if you do not agree with the terms of this
						agreement, you must not accept this agreement and may not access and
						use the Services. By accessing and using the Services, you
						acknowledge that you have read, understood, and agree to be bound by
						the terms of this Agreement. You acknowledge that this Agreement is
						a contract between you and COGen, LLC, even though it is electronic
						and is not physically signed by you, and it governs your use of the
						Services.
					</p>
					<div className='wpembed-index'>
						<h3 className='mb-4'>Table of contents</h3>
						<ol className='wpembed-index ml-4'>
							<li>
								<a href='#accounts-and-membership'>Accounts and membership</a>
							</li>
							<li>
								<a href='#billing-and-payments'>Billing and payments</a>
							</li>
							<li>
								<a href='#accuracy-of-information'>Accuracy of information</a>
							</li>
							<li>
								<a href='#third-party-services'>Third party services</a>
							</li>
							<li>
								<a href='#links-to-other-resources'>Links to other resources</a>
							</li>
							<li>
								<a href='#prohibited-uses'>Prohibited uses</a>
							</li>
							<li>
								<a href='#intellectual-property-rights'>
									Intellectual property rights
								</a>
							</li>
							<li>
								<a href='#disclaimer-of-warranty'>Disclaimer of warranty</a>
							</li>
							<li>
								<a href='#limitation-of-liability'>Limitation of liability</a>
							</li>
							<li>
								<a href='#indemnification'>Indemnification</a>
							</li>
							<li>
								<a href='#severability'>Severability</a>
							</li>
							<li>
								<a href='#dispute-resolution'>Dispute resolution</a>
							</li>
							<li>
								<a href='#changes-and-amendments'>Changes and amendments</a>
							</li>
							<li>
								<a href='#acceptance-of-these-terms'>
									Acceptance of these terms
								</a>
							</li>
							<li>
								<a href='#contacting-us'>Contacting us</a>
							</li>
						</ol>
					</div>
					<h2 className='mb-4' id='accounts-and-membership'>
						Accounts and membership
					</h2>
					<p style={{ textAlign: 'justify' }}>
						You must be at least 18 years of age to use the Services. By using
						the Services and by agreeing to this Agreement you warrant and
						represent that you are at least 18 years of age. If you create an
						account on the Services, you are responsible for maintaining the
						security of your account and you are fully responsible for all
						activities that occur under the account and any other actions taken
						in connection with it. We may, but have no obligation to, monitor
						and review new accounts before you may sign in and start using the
						Services. Providing false contact information of any kind may result
						in the termination of your account. You must immediately notify us
						of any unauthorized uses of your account or any other breaches of
						security. We will not be liable for any acts or omissions by you,
						including any damages of any kind incurred as a result of such acts
						or omissions. We may suspend, disable, or delete your account (or
						any part thereof) if we determine that you have violated any
						provision of this Agreement or that your conduct or content would
						tend to damage our reputation and goodwill. If we delete your
						account for the foregoing reasons, you may not re-register for our
						Services. We may block your email address and Internet protocol
						address to prevent further registration.
					</p>
					<h2 className='mb-4' id='billing-and-payments'>
						Billing and payments
					</h2>
					<p style={{ textAlign: 'justify' }}>
						You shall pay all fees or charges to your account in accordance with
						the fees, charges, and billing terms in effect at the time a fee or
						charge is due and payable. If auto-renewal is enabled for the
						Services you have subscribed for, you will be charged automatically
						in accordance with the term you selected. If, in our judgment, your
						purchase constitutes a high-risk transaction, we will require you to
						provide us with a copy of your valid government-issued photo
						identification, and possibly a copy of a recent bank statement for
						the credit or debit card used for the purchase. We reserve the right
						to change products and product pricing at any time. We also reserve
						the right to refuse any order you place with us. We may, in our sole
						discretion, limit or cancel quantities purchased per person, per
						household or per order. These restrictions may include orders placed
						by or under the same customer account, the same credit card, and/or
						orders that use the same billing and/or shipping address. In the
						event that we make a change to or cancel an order, we may attempt to
						notify you by contacting the e-mail and/or billing address/phone
						number provided at the time the order was made.
					</p>
					<h2 className='mb-4' id='accuracy-of-information'>
						Accuracy of Information
					</h2>
					<p style={{ textAlign: 'justify' }}>
						Occasionally there may be information on the Services that contains
						typographical errors, inaccuracies or omissions that may relate to
						availability, promotions and offers. We reserve the right to correct
						any errors, inaccuracies or omissions, and to change or update
						information or cancel orders if any information on the Services or
						Services is inaccurate at any time without prior notice (including
						after you have submitted your order). We undertake no obligation to
						update, amend or clarify information on the Services including,
						without limitation, pricing information, except as required by law.
						No specified update or refresh date applied on the Services should
						be taken to indicate that all information on the Services or
						Services has been modified or updated.
					</p>
					<h2 className='mb-4' id='third-party-services'>
						Third party services
					</h2>
					<p style={{ textAlign: 'justify' }}>
						If you decide to enable, access or use third party services, be
						advised that your access and use of such other services are governed
						solely by the terms and conditions of such other services, and we do
						not endorse, are not responsible or liable for, and make no
						representations as to any aspect of such other services, including,
						without limitation, their content or the manner in which they handle
						data (including your data) or any interaction between you and the
						provider of such other services. You irrevocably waive any claim
						against COGen, LLC with respect to such other services. COGen, LLC
						is not liable for any damage or loss caused or alleged to be caused
						by or in connection with your enablement, access or use of any such
						other services, or your reliance on the privacy practices, data
						security processes or other policies of such other services. You may
						be required to register for or log into such other services on their
						respective platforms. By enabling any other services, you are
						expressly permitting COGen, LLC to disclose your data as necessary
						to facilitate the use or enablement of such other service.
					</p>
					<h2 className='mb-4' id='links-to-other-resources'>
						Links to other resources
					</h2>
					<p style={{ textAlign: 'justify' }}>
						Although the Services may link to other resources (such as websites,
						mobile applications, etc.), we are not, directly or indirectly,
						implying any approval, association, sponsorship, endorsement, or
						affiliation with any linked resource, unless specifically stated
						herein. Some of the links on the Services may be &#8220;affiliate
						links&#8221;. This means if you click on the link and purchase an
						item, COGen, LLC will receive an affiliate commission. We are not
						responsible for examining or evaluating, and we do not warrant the
						offerings of, any businesses or individuals or the content of their
						resources. We do not assume any responsibility or liability for the
						actions, products, services, and content of any other third parties.
						You should carefully review the legal statements and other
						conditions of use of any resource which you access through a link on
						the Services. Your linking to any other off-site resources is at
						your own risk.
					</p>
					<h2 className='mb-4' id='prohibited-uses'>
						Prohibited uses
					</h2>
					<p style={{ textAlign: 'justify' }}>
						In addition to other terms as set forth in the Agreement, you are
						prohibited from using the Services or Content: (a) for any unlawful
						purpose; (b) to solicit others to perform or participate in any
						unlawful acts; (c) to violate any international, federal, provincial
						or state regulations, rules, laws, or local ordinances; (d) to
						infringe upon or violate our intellectual property rights or the
						intellectual property rights of others; (e) to harass, abuse,
						insult, harm, defame, slander, disparage, intimidate, or
						discriminate based on gender, sexual orientation, religion,
						ethnicity, race, age, national origin, or disability; (f) to submit
						false or misleading information; (g) to upload or transmit viruses
						or any other type of malicious code that will or may be used in any
						way that will affect the functionality or operation of the Services,
						third party products and services, or the Internet; (h) to spam,
						phish, pharm, pretext, spider, crawl, or scrape; (i) for any obscene
						or immoral purpose; or (j) to interfere with or circumvent the
						security features of the Services, third party products and
						services, or the Internet. We reserve the right to terminate your
						use of the Services for violating any of the prohibited uses.
					</p>
					<h2 className='mb-4' id='intellectual-property-rights'>
						Intellectual property rights
					</h2>
					<p style={{ textAlign: 'justify' }}>
						&#8220;Intellectual Property Rights&#8221; means all present and
						future rights conferred by statute, common law or equity in or in
						relation to any copyright and related rights, trademarks, designs,
						patents, inventions, goodwill and the right to sue for passing off,
						rights to inventions, rights to use, and all other intellectual
						property rights, in each case whether registered or unregistered and
						including all applications and rights to apply for and be granted,
						rights to claim priority from, such rights and all similar or
						equivalent rights or forms of protection and any other results of
						intellectual activity which subsist or will subsist now or in the
						future in any part of the world. This Agreement does not transfer to
						you any intellectual property owned by COGen, LLC or third parties,
						and all rights, titles, and interests in and to such property will
						remain (as between the parties) solely with COGen, LLC. All
						trademarks, service marks, graphics and logos used in connection
						with the Services, are trademarks or registered trademarks of COGen,
						LLC or its licensors. Other trademarks, service marks, graphics and
						logos used in connection with the Services may be the trademarks of
						other third parties. Your use of the Services grants you no right or
						license to reproduce or otherwise use any of COGen, LLC or third
						party trademarks.
					</p>
					<h2 className='mb-4' id='disclaimer-of-warranty'>
						Disclaimer of warranty
					</h2>
					<p style={{ textAlign: 'justify' }}>
						You agree that such Service is provided on an &#8220;as is&#8221;
						and &#8220;as available&#8221; basis and that your use of the
						Services is solely at your own risk. We expressly disclaim all
						warranties of any kind, whether express or implied, including but
						not limited to the implied warranties of merchantability, fitness
						for a particular purpose and non-infringement. We make no warranty
						that the Services will meet your requirements, or that the Service
						will be uninterrupted, timely, secure, or error-free; nor do we make
						any warranty as to the results that may be obtained from the use of
						the Service or as to the accuracy or reliability of any information
						obtained through the Service or that defects in the Service will be
						corrected. You understand and agree that any material and/or data
						downloaded or otherwise obtained through the use of Service is done
						at your own discretion and risk and that you will be solely
						responsible for any damage or loss of data that results from the
						download of such material and/or data. We make no warranty regarding
						any goods or services purchased or obtained through the Service or
						any transactions entered into through the Service unless stated
						otherwise. No advice or information, whether oral or written,
						obtained by you from us or through the Service shall create any
						warranty not expressly made herein.
					</p>
					<h2 className='mb-4' id='limitation-of-liability'>
						Limitation of liability
					</h2>
					<p style={{ textAlign: 'justify' }}>
						To the fullest extent permitted by applicable law, in no event will
						COGen, LLC, its affiliates, directors, officers, employees, agents,
						suppliers or licensors be liable to any person for any indirect,
						incidental, special, punitive, cover or consequential damages
						(including, without limitation, damages for lost profits, revenue,
						sales, goodwill, use of content, impact on business, business
						interruption, loss of anticipated savings, loss of business
						opportunity) however caused, under any theory of liability,
						including, without limitation, contract, tort, warranty, breach of
						statutory duty, negligence or otherwise, even if the liable party
						has been advised as to the possibility of such damages or could have
						foreseen such damages. To the maximum extent permitted by applicable
						law, the aggregate liability of COGen, LLC and its affiliates,
						officers, employees, agents, suppliers and licensors relating to the
						services will be limited to an amount no greater than one dollar or
						any amounts actually paid in cash by you to COGen, LLC for the prior
						one month period prior to the first event or occurrence giving rise
						to such liability. The limitations and exclusions also apply if this
						remedy does not fully compensate you for any losses or fails of its
						essential purpose.
					</p>
					<h2 className='mb-4' id='indemnification'>
						Indemnification
					</h2>
					<p style={{ textAlign: 'justify' }}>
						You agree to indemnify and hold COGen, LLC and its affiliates,
						directors, officers, employees, agents, suppliers and licensors
						harmless from and against any liabilities, losses, damages or costs,
						including reasonable attorneys&#8217; fees, incurred in connection
						with or arising from any third party allegations, claims, actions,
						disputes, or demands asserted against any of them as a result of or
						relating to your Content, your use of the Services or any willful
						misconduct on your part.
					</p>
					<h2 className='mb-4' id='severability'>
						Severability
					</h2>
					<p style={{ textAlign: 'justify' }}>
						All rights and restrictions contained in this Agreement may be
						exercised and shall be applicable and binding only to the extent
						that they do not violate any applicable laws and are intended to be
						limited to the extent necessary so that they will not render this
						Agreement illegal, invalid or unenforceable. If any provision or
						portion of any provision of this Agreement shall be held to be
						illegal, invalid or unenforceable by a court of competent
						jurisdiction, it is the intention of the parties that the remaining
						provisions or portions thereof shall constitute their agreement with
						respect to the subject matter hereof, and all such remaining
						provisions or portions thereof shall remain in full force and
						effect.
					</p>
					<h2 className='mb-4' id='dispute-resolution'>
						Dispute resolution
					</h2>
					<p style={{ textAlign: 'justify' }}>
						The formation, interpretation, and performance of this Agreement and
						any disputes arising out of it shall be governed by the substantive
						and procedural laws of Arizona, United States without regard to its
						rules on conflicts or choice of law and, to the extent applicable,
						the laws of United States. The exclusive jurisdiction and venue for
						actions related to the subject matter hereof shall be the courts
						located in Arizona, United States, and you hereby submit to the
						personal jurisdiction of such courts. You hereby waive any right to
						a jury trial in any proceeding arising out of or related to this
						Agreement. The United Nations Convention on Contracts for the
						International Sale of Goods does not apply to this Agreement.
					</p>
					<h2 className='mb-4' id='changes-and-amendments'>
						Changes and amendments
					</h2>
					<p style={{ textAlign: 'justify' }}>
						We reserve the right to modify this Agreement or its terms related
						to the Services at any time at our discretion. When we do, we will
						revise the updated date at the bottom of this page, send you an
						email to notify you. We may also provide notice to you in other ways
						at our discretion, such as through the contact information you have
						provided.
					</p>
					<p style={{ textAlign: 'justify' }}>
						An updated version of this Agreement will be effective immediately
						upon the posting of the revised Agreement unless otherwise
						specified. Your continued use of the Services after the effective
						date of the revised Agreement (or such other act specified at that
						time) will constitute your consent to those changes.
					</p>
					<h2 className='mb-4' id='acceptance-of-these-terms'>
						Acceptance of these terms
					</h2>
					<p style={{ textAlign: 'justify' }}>
						You acknowledge that you have read this Agreement and agree to all
						its terms and conditions. By accessing and using the Services you
						agree to be bound by this Agreement. If you do not agree to abide by
						the terms of this Agreement, you are not authorized to access or use
						the Services.
					</p>
					<h2 className='mb-4' id='contacting-us'>
						Contacting us
					</h2>
					<p style={{ textAlign: 'justify' }}>
						If you have any questions, concerns, or complaints regarding this
						Agreement, we encourage you to contact us using the details below:
					</p>
					<p>
						<a href='&#109;&#097;&#105;&#108;&#116;&#111;&#058;&#115;&#117;&#112;&#112;ort&#64;g&#101;tcog&#101;n&#46;c&#111;m'>
							&#115;u&#112;po&#114;&#116;&#64;&#103;etc&#111;&#103;e&#110;&#46;c&#111;m
						</a>
					</p>
					<p>This document was last updated on November 9, 2023</p>
					<p className name='madewith'>
						<a
							href='https://www.websitepolicies.com/?via=madewithbadge'
							target='_blank'
							rel='noreferrer'
						>
							{/* <img width="200" height="25" alt="Made with WebsitePolicies" src="https://cdn.websitepolicies.io/img/badge.png" srcset="https://cdn.websitepolicies.io/img/badge_2x.png 2x" /> */}
						</a>
					</p>
				</div>
			</Container>
			<Footer />
		</Container>
	);
}
export default CogenRegistrationTermOfServices;
